/** A shared drive's root opens at `/drive/folders/<id>`, optionally under an
 * account selector (`/drive/u/<n>/`), and the browser often appends a `usp`
 * query or a fragment. Only that path shape is accepted: any other Drive URL
 * (a file, a doc, "My Drive") would yield an id the connector cannot grant in.
 */
const DRIVE_FOLDER_PATH = /^\/drive\/(?:u\/\d+\/)?folders\/([\w-]+)\/?$/;

export const DRIVE_URL_HINT =
  "Enter the shared drive's URL as it appears in the browser when the drive " +
  "is open, e.g. https://drive.google.com/drive/folders/0AbCdEfGhIjKlMnOpQr";

/** Google's ID for a shared drive, read from the drive's URL, or `undefined`
 * if the URL is not one.
 *
 * Does not distinguish a shared drive's root from a folder inside it — both
 * open at `/drive/folders/<id>`. The connector refuses any item whose `driveId`
 * is not this id, so a folder's URL fails every grant rather than granting
 * outside the drive.
 */
export const googleDriveIdFromUrl = (url: string): string | undefined => {
  let parsed: URL;
  try {
    parsed = new URL(url.trim());
  } catch {
    return undefined;
  }
  if (parsed.protocol !== "https:" || parsed.hostname !== "drive.google.com")
    return undefined;
  return DRIVE_FOLDER_PATH.exec(parsed.pathname)?.[1];
};
